import React, { useState } from "react";
import img1 from "../icon23.png";
import img2 from "../2.png";
import img3 from "../3.png";
import img4 from "../4.png";
import img5 from "../Rectangle1.png";
import img6 from "../Rectangle2.png";

import img7 from "../Rectangle3.png";

import img8 from "../Rectangle4.png";

const data = [
  {
    img: img1,
    value: "390M",
    label: "MRF Record Count",
    hoverimg: null,
    hoverValue: null,
    hoverLabel: (
      <div className="d-flex flex-row align-content-between gap-2">
        <div>
          <img src={img7}></img>
        </div>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column">
            <div>
              <h5
                className="mb-2"
                style={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: "#3B3A3A",
                }}
              >
                MRF Record Count
              </h5>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "200px",
              justifyContent: "space-between",
            }}
          >
            <div>
              CRE covers over 390M data set which is equivalent to 65% of the
              total counts.
            </div>

            {/* <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                17
              </h5>
              <p className="mb-0">Payor</p>
            </div>
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                2
              </h5>
              <p className="mb-0">Carrier</p>
            </div>
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                11
              </h5>
              <p className="mb-0">TPAs</p>
            </div> */}
          </div>
        </div>
      </div>
    ),
  },
  {
    img: img1,
    value: "19",
    label: "Total Number of Carriers",
    hoverimg: img7,
    hoverValue: null,
    hoverLabel: (
      <div className="d-flex flex-row align-content-between gap-2">
        <div>
          <img src={img7}></img>
        </div>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column">
            <div>
              {" "}
              <h5
                className="mb-3"
                style={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: "#3B3A3A",
                }}
              >
                Carrier Breakdown
              </h5>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "200px",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                17
              </h5>
              <p className="mb-0">Payor</p>
            </div>
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                2
              </h5>
              <p className="mb-0">Carrier</p>
            </div>
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                11
              </h5>
              <p className="mb-0">TPAs</p>
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    img: img1,
    value: "250",
    label: "Total Networks",
    hoverimg: img8,
    hoverValue: null,
    hoverLabel: (
      <div className="d-flex flex-row align-content-between gap-2">
        <div>
          <img src={img7}></img>
        </div>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column">
            <div>
              {" "}
              <h5
                className="mb-3"
                style={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: "#3B3A3A",
                }}
              >
                Networks Breakdown
              </h5>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "190px",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                17
              </h5>
              <p className="mb-0">National</p>
            </div>
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                2
              </h5>
              <p className="mb-0">Local</p>
            </div>
            {/* <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                1
              </h5>
              <p className="mb-0">TPAs</p>
            </div> */}
          </div>
        </div>
      </div>
    ),
  },
  {
    img: img1,
    value: "607K",
    label: "Billing NPI Count",
    hoverValue: null,
    hoverLabel: (
      <div className="d-flex flex-row align-content-between gap-2">
        <div>
          <img src={img7}></img>
        </div>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column">
            <div>
              {" "}
              <h5
                className="mb-3"
                style={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: "#3B3A3A",
                }}
              >
                NPI / Provider Type NPI Count
              </h5>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "190px",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                315,117
              </h5>
              <p className="mb-0">Organization</p>
            </div>
            <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                303,779
              </h5>
              <p className="mb-0">Individual</p>
            </div>
            {/* <div>
              <h5 className="mb-0" style={{ fontSize: "15px" }}>
                11
              </h5>
              <p className="mb-0">TPAs</p>
            </div> */}
          </div>
        </div>
      </div>
    ),
  },
];

const DashboardCard = ({
  img,
  value,
  label,
  hoverValue,
  hoverLabel,
  hoverimg,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="Non-hover"
      style={{
        width: "24%",
        border: "1px solid  #F0F0F0",
        borderRadius: "6px",
        display: "flex",
        flexDirection: "row",
        alignItems: hovered ? "top" : "center",
        justifyContent: hovered ? "left" : "space-between",
        padding: "20px",
        transition: "0.25s ease-in-out",
        gap: hovered ? "10px" : "20px",
        height: "110px",

        backgroundColor: hovered ? "white" : "#FAFDFF",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <p
          className="mb-0"
          style={{
            fontSize: "18px",
            fontWeight: "700",
            color: "#3B3A3A",
          }}
        >
          {hovered ? hoverValue : value}
        </p>
        <p
          className="mb-0"
          style={{
            fontSize: "12px",
            fontWeight: "600",
            color: "#75738C",
          }}
        >
          {hovered ? hoverLabel : label}
        </p>
      </div>
      {!hovered && <img src={img} style={{ height: "27px", width: "27px" }} />}
    </div>
  );
};

const Dashboard = () => {
  return (
    <div
      style={{
        display: "flex",
        borderRadius: "6px",
        marginBottom: "15px",
        justifyContent: "space-between",
      }}
    >
      {data.map((item, index) => (
        <DashboardCard key={index} {...item} />
      ))}
    </div>
  );
};

export default Dashboard;
